var arAR = {
  locale: 'ar',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر،'],
    monthList: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر،'],
    shortDayList: ['الأحد،', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    dayList: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
    shortestDayList: ['الأحد،', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
  },
  'dynamic-date': {
    day: 'يوم',
    week: 'أسبوع',
    month: 'شهر',
    quarter: 'ربع',
    year: 'سنة',
    before: 'قبل ${value}${unit}'
  },
  'auto-complete.empty': 'لا توجد بيانات',
  'select.selected-count': 'العناصر المحددة ${count}',
  'date-time-picker.date': 'حدد التاريخ',
  'image-view.zoom-out': 'تصغير',
  'input.placeholder': 'يرجى الدخول',
  'empty.text': 'لا توجد بيانات',
  'date-picker.cancel': 'إلغاء',
  'date-picker.end': 'وقت الانتهاء',
  'cascader.empty': 'لا توجد بيانات',
  'upload.drop': 'اسحب الملفات هنا أو',
  'color.custom': 'تخصيص اللون',
  'cascader.titles': ['المستوى الأول', 'المستوى الثاني', 'المستوى الثالث', 'المستوى الرابع', 'المستوى الخامس', 'المستوى السادس', 'المستوى السابع', 'المستوى الثامن'],
  'date-comparison.error-target': 'حدد وقت انتهاء المقارنة',
  'transfer.empty': 'لا توجد بيانات',
  'select.search.placeholder': 'يرجى الدخول',
  'upload.click': 'انقر للرفع',
  'date-time-picker.placeholder': 'يرجى الدخول',
  'pager.jump': 'إعادة التوجيه',
  'tree-select.placeholder': 'يرجى الدخول',
  'dynamic-date.interval': 'الفاصل الزمني',
  'modal.cancel': 'إلغاء',
  'image-view.rotate': 'تدوير',
  'tabs.more': 'المزيد',
  'popover.ok': 'تأكيد',
  'transfer.placeholder': 'يرجى الدخول',
  'date.month': 'شهر',
  'select.selected': 'تم التحديد',
  'popover.cancel': 'إلغاء',
  'image-view.prev': 'السابق',
  'table.emptyText': 'لا توجد بيانات',
  'date-time-picker.ok': 'تأكيد',
  'table.filter.confirm': 'تأكيد',
  'tree-select.empty': 'لا توجد بيانات',
  'dynamic-date.fixed-date': 'تاريخ ثابت',
  'date-comparison.compare': 'قارن',
  'auto-complete.placeholder': 'يرجى الدخول',
  'time-picker.placeholder': 'حدد الوقت',
  'date.month-first': true,
  'select.clear': 'مسح',
  'date.year': '${year}',
  'date-comparison.yoy': 'هذه الفترة الزمنية من العام الماضي',
  'image-view.zoom-to-origin': 'الأصل',
  'schedule.title': 'التاريخ/الوقت',
  'schedule.clear': 'مسح',
  'date-time-picker.end': 'حدد تاريخ ووقت الانتهاء',
  'dynamic-date.customize': 'تخصيص',
  'date-picker.apply': 'تطبيق',
  'schedule.selected': 'الوقت المحدد',
  'dynamic-date.dynamic-date': 'تاريخ ديناميكي',
  'select.placeholder': 'يرجى تحديد',
  'schedule.separator': '،',
  'cascader.search': 'يرجى الدخول',
  'date-picker.invalid-range': 'يتجاوز النطاق الزمني المحدد النطاق القابل للتحديد. يرجى تحديد نطاق صالح.',
  'dynamic-date.date-preview': 'معاينة التاريخ',
  'select.empty': 'لا توجد بيانات',
  'image-view.next': 'التالى',
  'date-time-picker.now': 'الآن',
  'date-time-picker.time': 'حدد الوقت',
  'tree.empty': 'لا توجد بيانات',
  'pager.total': '${total} إجمالي السجلات',
  'image-view.zoom-in': 'تكبير',
  'date-picker.placeholder': 'حدد التاريخ',
  'textarea.placeholder': 'يرجى الدخول',
  'date.week': 'أسبوع',
  'pager.size': '${count} من السجلات/الصفحات',
  'modal.ok': 'تأكيد',
  'date-picker.start': 'وقت البدء',
  'table.filter.reset': 'إعادة تعيين',
  'image-view.zoom-to-fit': 'ملائم',
  'pager.page.placeholder': 'يرجى الدخول',
  'select.select-all': 'حدد الكل',
  'list-viewer.empty': 'لا توجد بيانات',
  'date-comparison.compare-text': 'مقارنة',
  'transfer.source': 'قائمة المصادر',
  'date-time-picker.start': 'حدد تاريخ ووقت البدء',
  'date-comparison.error-source': 'حدد وقت بدء المقارنة',
  'upload.error.overflow-count': 'تم تجاوز الحد الأقصى لعدد الملفات',
  'date-comparison.placeholder': 'وقت البدء - وقت الانتهاء',
  'time-range-picker.placeholder': 'وقت البدء - وقت الانتهاء',
  'date-comparison.mom': 'مقارنة بالفترة الزمنية السابقة',
  'transfer.target': 'القائمة المستهدفة'
};
export default arAR;